import { GridFilterModel, GridSortModel } from '@mui/x-data-grid';

export type GridFieldMap = Record<string, string>;

export const toFilterValue = (value: unknown): string | undefined => {
  if (value === undefined || value === null) {
    return undefined;
  }
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) {
      return undefined;
    }
    return value.toISOString().substring(0, 10);
  }
  if (typeof value === 'boolean') {
    return String(value);
  }
  const stringValue =
    typeof value === 'object' && value !== null
      ? JSON.stringify(value).trim()
      : String(value as string | number).trim();
  if (stringValue === '') {
    return undefined;
  }
  const isoDate = /^(\d{4}-\d{2}-\d{2})T\d/.exec(stringValue);
  return isoDate ? isoDate[1] : stringValue;
};

export const getSortParams = (sortModel: GridSortModel | undefined, fieldMap: GridFieldMap) => {
  const sortItem = sortModel?.[0];
  const sortBy = sortItem && fieldMap[sortItem.field];
  if (!sortBy) {
    return {};
  }
  return { sortBy, ordering: sortItem.sort === 'desc' ? 'desc' : 'asc' };
};

export const getFilterParams = (
  filterModel: GridFilterModel | undefined,
  fieldMap: GridFieldMap
) => {
  const filter = (filterModel?.items ?? []).reduce<Record<string, string>>((acc, item) => {
    const field = fieldMap[item.field];
    const value = toFilterValue(item.value);
    if (!field || value === undefined) {
      return acc;
    }
    acc[field] = value;
    return acc;
  }, {});

  return Object.keys(filter).length ? { filter } : {};
};
